import React, { Component } from "react";
import styles from "./reportContructor.module.scss";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";
import ReportDashboardConstructorItem from "./ReportDashboardConstructorItem";
import { v4 as uuidv4 } from "uuid";

class ReportDashboardsConstructor extends Component {
  constructor(props) {
    super(props);
  }

  getRowDashboar(dashboards) {
    return (
      <div key={uuidv4()} className={styles.rowDashboarContainer}>
        {dashboards.map((x) => {
          return <ReportDashboardConstructorItem key={uuidv4()} dashboard={x} />;
        })}
      </div>
    );
  }

  render() {
    const { dashboards } = this.props;

    return (
      <div>
        <div>
          <b>{"Панель общей информации:"}</b>
        </div>
        <div className={styles.dashboardsConstructorContainer}>
          {dashboards.map((x) => {
            return this.getRowDashboar(x);
          })}
        </div>
      </div>
    );
  }
}

export default withCustomReport(withReportsList(React.memo(ReportDashboardsConstructor)));
